<template>
    <div>
        <div class="table-layout">
            <el-table :data="goodsOrderRecordList" border style="width: 100%" >
                <el-table-column prop="actorName" label="操作人" width="180" align="left"></el-table-column>
                <el-table-column prop="action" label="动作" width="180" align="center"></el-table-column>
                <el-table-column prop="actRole" label="操作人身份" width="260" align="left"></el-table-column>
                <el-table-column prop="extraInfo" label="附加信息" show-overflow-tooltip align="left"></el-table-column>
                <el-table-column prop="ts" label="操作时间" align="center" width="260"></el-table-column>
            </el-table>
        </div>
        <div class="pagination-layout">
            <el-pagination background layout="total, sizes, prev, pager, next, jumper" v-if="totalCount > 0" :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange"></el-pagination>
        </div>
    </div>
</template>


<script>

    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import { getDefaultPageSizes } from '../../app.conf';

    import goodsOrderApi from '../../api/goodsOrder'

    export default {
        name: 'swb-goods-order-record-list',
        desc: '订单操作记录',
        props: ['goodsOrderId'],
        data: function () {
            return {
                //
                pageNumber: 1,
                totalCount: 1,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                //
                goodsOrderRecordList: []
            }
        },
        created: function () {
            //
            this.pageSize = this.pageSizes.first();
            //
            this.getGoodsOrderRecordList();
        },
        methods: {
            handleSizeChange: function (val) {
                let curStartIndex = (this.pageNumber - 1) * this.pageSize;
                this.pageSize = val;
                let newPageNumber = Math.max(1, Math.ceil(curStartIndex / this.pageSize));
                this.handlePageChange(newPageNumber);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                this.getGoodsOrderRecordList();
            },
            getGoodsOrderRecordList: function () {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber
                };
                let filterItems = {};
                if(!Utils.isNoB(self.goodsOrderId)) {
                    filterItems.orderId = self.goodsOrderId;
                }
                postData.filterItems = filterItems;
                //
                let msgBoxDlg = MsgBox.loading();
                goodsOrderApi.getGoodsOrderRecordList(postData, function (result) {
                    msgBoxDlg.close();
                    if(result.type === "info") {
                        let data = result.data;
                        self.goodsOrderRecordList = data.rows;
                        //
                        let pagination = data.pagination;
                        self.totalCount = pagination.totalCount;
                        self.pageNumber = pagination.pageNumber;
                        self.pagesize = pagination.pageSize;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/order/GoodsOrderRecordList.vue